import { Interval } from 'luxon';

import { EntityType } from 'common/types';

import { FtuByVenueInsight, FtuByVenueTableSortBy } from './types';
import merchantGatewayApi from '../../api';
import { SortOrder } from '../types';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getFtuByVenueInsightForEntity = ({
  entityType,
  entityId,
  interval,
  limit,
  cursor,
  sortBy,
  sortOrder,
  locale,
}: {
  entityType: Exclude<EntityType, 'venue'>;
  entityId: string;
  interval: Interval;
  limit?: number;
  cursor?: string;
  sortBy?: FtuByVenueTableSortBy;
  sortOrder?: SortOrder;
  locale: string;
}) => {
  return merchantGatewayApi
    .get<FtuByVenueInsight>(`${getBaseUrl(entityType, entityId)}/ftu-by-venue`, {
      headers: { 'Accept-Language': locale },
      params: {
        ...getDateRangeForApiCall(interval),
        limit,
        cursor,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    })
    .then(response => response.data);
};
